import { render, staticRenderFns } from "./CooperativeIndexItem.vue?vue&type=template&id=2a4f69f9&scoped=true&"
import script from "./CooperativeIndexItem.vue?vue&type=script&lang=js&"
export * from "./CooperativeIndexItem.vue?vue&type=script&lang=js&"
import style0 from "./CooperativeIndexItem.vue?vue&type=style&index=0&id=2a4f69f9&scoped=true&lang=less&"
import style1 from "./CooperativeIndexItem.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4f69f9",
  null
  
)

export default component.exports